import { useEffect } from 'react';
import useQueryParams from './useQueryParams';

function useNodeHighlighter(item = '') {
  const queryParams = useQueryParams();
  const toScrollElementID = queryParams.get(item);

  useEffect(() => {
    function scrollToTestDiv() {
      const divElement = document.getElementById(toScrollElementID);
      if (!divElement) return;
      if (divElement.closest('.level1')) {
        divElement.closest('.level1') &&
          divElement.closest('.level1').scrollIntoView({
            behavior: 'smooth',
            alignToTop: false,
            block: 'center',
            inline: 'nearest',
          });
        divElement.closest('.level1') && divElement.closest('.level1').classList.add('highlighter');
        return;
      }
      divElement &&
        divElement.scrollIntoView({
          behavior: 'smooth',
          alignToTop: false,
          block: 'center',
          inline: 'nearest',
        });
      divElement && divElement.classList.add('highlighter');
    }

    setTimeout(() => {
      scrollToTestDiv(toScrollElementID);
    }, 2000);

    return () => {};
  }, [toScrollElementID]);
}

export default useNodeHighlighter;
